import { render, staticRenderFns } from "./UserDetailsContactInformationRevisionTable.vue?vue&type=template&id=4a286605&scoped=true&"
import script from "./UserDetailsContactInformationRevisionTable.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsContactInformationRevisionTable.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsContactInformationRevisionTable.vue?vue&type=style&index=0&id=4a286605&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a286605",
  null
  
)

export default component.exports